/**
 * 语义化版本号比较
 * @param a 版本号 a，形如 "1.2.0"
 * @param b 版本号 b，形如 "1.2.0"
 * @returns 1: a > b；-1: a < b；0: a == b
 */
export function compareVersion(a: string, b: string): number {
  const pa = String(a || '0').split('.').map((v) => Number(v) || 0)
  const pb = String(b || '0').split('.').map((v) => Number(v) || 0)
  const len = Math.max(pa.length, pb.length)
  for (let i = 0; i < len; i++) {
    const va = pa[i] || 0
    const vb = pb[i] || 0
    if (va > vb) return 1
    if (va < vb) return -1
  }
  return 0
}

/**
 * a 是否大于等于 b
 */
export function gteVersion(a: string, b: string): boolean {
  return compareVersion(a, b) >= 0
}
